var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCalenderLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8761_19696)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7 14.4C13.3075 14.4 12.2 15.5075 12.2 16.9V32.4C12.2 33.7924 13.3075 34.9 14.7 34.9H33.5C34.8925 34.9 36 33.7924 36 32.4V16.9C36 15.5075 34.8925 14.4 33.5 14.4H14.7ZM10 16.9C10 14.2924 12.0925 12.2 14.7 12.2H33.5C36.1075 12.2 38.2 14.2924 38.2 16.9V32.4C38.2 35.0075 36.1075 37.1 33.5 37.1H14.7C12.0925 37.1 10 35.0075 10 32.4V16.9Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.1001 21.2996H11.1001V19.0996H37.1001V21.2996Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5 17V10H18.7V17H16.5Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.5 17V10H31.7V17H29.5Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4002 24.4996C16.8002 25.0996 16.8002 26.0996 17.4002 26.7996C18.0002 27.3996 19.0002 27.3996 19.7002 26.7996C20.3002 26.1996 20.3002 25.1996 19.7002 24.4996C19.0002 23.7996 18.0002 23.7996 17.4002 24.4996Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0002 24.4996C22.4002 25.0996 22.4002 26.0996 23.0002 26.7996C23.6002 27.3996 24.6002 27.3996 25.3002 26.7996C25.9002 26.1996 25.9002 25.1996 25.3002 24.4996C24.6002 23.7996 23.6002 23.7996 23.0002 24.4996Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8002 24.4996C30.2002 23.8996 29.2002 23.8996 28.5002 24.4996C27.9002 25.0996 27.9002 26.0996 28.5002 26.7996C29.1002 27.3996 30.1002 27.3996 30.8002 26.7996C31.5002 26.0996 31.5002 25.0996 30.8002 24.4996Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4002 29.1997C16.8002 29.7997 16.8002 30.7997 17.4002 31.4997C18.0002 31.9997 19.0002 31.9997 19.6002 31.3997C20.2002 30.7997 20.2002 29.7997 19.6002 29.0997C19.0002 28.3997 18.0002 28.4997 17.4002 29.1997Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0002 29.1998C22.4002 29.7998 22.4002 30.7998 23.0002 31.4998C23.6002 32.0998 24.6002 32.0998 25.3002 31.4998C25.9002 30.8998 25.9002 29.8998 25.3002 29.1998C24.6002 28.4998 23.6002 28.4998 23.0002 29.1998Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8003 29.2C30.2003 28.6 29.2003 28.6 28.5003 29.2C27.9003 29.8 27.9003 30.8 28.5003 31.5C29.1003 32.1 30.1003 32.1 30.8003 31.5C31.5003 30.8 31.5003 29.8 30.8003 29.2Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8761_19696"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28.2,
    height: 27.1,
    fill: "white",
    transform: "translate(10 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCalenderLight);
export default __webpack_public_path__ + "static/media/icon_calender_light.b436eac7.svg";
export { ForwardRef as ReactComponent };